import { InjectionToken } from '@angular/core';

export const GOOGLE_ANALYTICS_ID = new InjectionToken<string>('');
export const GOOGLE_TAG_MANAGER_ID = new InjectionToken<string>('');
